import { render, staticRenderFns } from "./mangeUserCanUseTemplate.vue?vue&type=template&id=12dbb154&scoped=true&"
import script from "./mangeUserCanUseTemplate.vue?vue&type=script&lang=js&"
export * from "./mangeUserCanUseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./mangeUserCanUseTemplate.vue?vue&type=style&index=0&id=12dbb154&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dbb154",
  null
  
)

export default component.exports